module.exports = __webpack_public_path__ + "static/media/281085.887fb9c2.png";